export default function StickyElement(stickyEl, stopStickyEl) {
	const stickyElem = document.getElementById(stickyEl);
	const stopStickyElem = document.getElementById(stopStickyEl);
	if (stickyElem == null || stopStickyElem == null) return false;
	let yOffset = document.scrollingElement.scrollTop;

	const findOffest = (elem) => {
		const rect = elem.getBoundingClientRect();
		const bodyElem = document.body;
		return {
			top: rect.top + bodyElem.scrollTop,
			left: rect.left + bodyElem.scrollLeft
		};
	};

	const stickyElemTop = findOffest(stickyElem).top;
	const stopStickyElemTop = findOffest(stopStickyElem).top;
	const maxY = stopStickyElemTop - stickyElem.offsetHeight;

	const handleStickyElem = () => {
		if (yOffset > stopStickyElemTop) {
			stickyElem.classList.add("sticky");
		} else {
			stickyElem.classList.remove("sticky");
		}
	};

	let throttleTimer;

	const throttle = (callback, time) => {
		if (throttleTimer) return;

		throttleTimer = true;
		setTimeout(() => {
			callback();
			throttleTimer = false;
		}, time);
	};

	const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

	window.addEventListener("scroll", () => {
		if (mediaQuery && !mediaQuery.matches) {
			throttle(handleStickyElem, 250);
		}
	});
}
